$(function () {
  if ( _.get($.siteConfiguration,"show_registration_explanation" ) ){
    renderMarkdown($('#registration-explanation'), $.polyglot.t('registration_explanation', $.interpolations));
  }

  if ( _.get($.siteConfiguration,"registration_model_field.display_help" ) ){
    renderMarkdown($('#model-help'), $.polyglot.t('model_help_text', $.interpolations));
  }

  if ( _.get($.siteConfiguration,"show_registration_disclaimer" ) ){
    renderMarkdown($('#registration-disclaimer'), $.polyglot.t('registration_disclaimer', $.interpolations));
  }
});

$(document).ready(function() {
  renderMarkdown($('#footer-text'), $.polyglot.t('footer_text', $.interpolations));
  if ( _.get($.siteConfiguration,"enable_footer_links" ) ){
    renderMarkdown($('#footer_links'), $.polyglot.t('footer_links', $.interpolations));
  }
});

$(function() {
  

  if ($(":input[name*='user[email]']").length) {
    $(":input[name*='user[email]']").rules("add", {
      regex: "^[A-Za-z0-9!%&'*+/=?^_`{|}~-]+(?:.[A-Za-z0-9!%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$".replace(new RegExp("\\.", "g"), "\\\."),
      required: $(":input[name*='user[email]']")[0].required,
      messages: {
        regex: $.polyglot.t('validations.email')
      }
    });
  }
  
  
  if ($(".mask-money").length) {
    $(".mask-money").on('input', function() {
      if(this.value.length > 0) {
        if (this.value.length === 1) { this.value = '0'+this.value; }
        this.value = parseFloat(this.value.replace(/[^\d]/g,'').replace(/(\d\d?)$/,'.$1')).toFixed(2);
      }
    });
    $(".mask-money").on('blur', function() {
      if($(".mask-money").val() <=0 ){ $(".mask-money").val('');}
    });
  }
  // Price paid validation
  $.validator.addMethod('strictPrice', function(value, element) {
    return $(element).data("valid_price");
  }, $.polyglot.t('validations.required'));

  if ($(":input[name*='registration[price_paid]']").length) {
    var price_field = $(":input[name*='registration[price_paid]']");
    var isRequired = price_field[0].required
    if ( _.get($.siteConfiguration,"registration_price_paid_field.display" )){
      price_field.data("required_price", isRequired);
      price_field.rules('add', {
        strictPrice: isRequired
      });
      $("#registria_form").on('blur change keyup', price_field, function() {
        if (price_field.val()) {
          price_field.data("valid_price", true);
        }
        else {
          price_field.data("valid_price", false);
        }
      });
    }
  }
});
$(function() {
  // Weber serial validation
  if($("#serial").length && $.siteConfiguration.site_name === "Weber" ){
    var bypass = $.siteConfiguration.registration_serial_number_field.bypass;
    var requiredAttempts = $.siteConfiguration.registration_serial_number_field.required_attempts;
    var attempts = 0;
    var subdomain = window.location.hostname.split(".")[0];
    var translate = function translate(text) {
      switch (text) {
        case 'invalid/not found serial number':
          return $.polyglot.t('validations.serial_number_invalid');
        case 'serial number already used':
          return $.polyglot.t('validations.serial_number_used');
        case 'serial number not valid for entered model':
          return $.polyglot.t('validations.serial_number_mismatch');
        case 'invalid purchase date specified':
          return $.polyglot.t('validations.purchase_date_invalid');
      }
    }

    $("#serial").rules("add",{
      "remote" :{
        param: {
          url: '/' + subdomain + '/validate_serial?',
          type: "POST",
          async: true,
          data:
          {
            serial_number: function(){
              return $("#serial").val();
            },
            product_id: function(){
              return $("#product").val();
            },
            purchase_date: function(){
              return $("#purchase_date").val();
            }
          },
          dataFilter: function(data) {
            data=JSON.parse(data);
            attempts++;
            if(data.success) {
              $("#model").val(data.product_name+' ('+data.model+')');
              $('#product').val(data.product_id);
              document.getElementById("model").style.textTransform = "capitalize";
              $("label[for='model'] .frauto-list > li.selected").removeClass('selected');
              $('label[for="serial"]').css("margin-bottom","0px");
              $('#registration_status_short_code').val("");
              $('#model').prop('readonly', true);
              return true;
            } else if (bypass && attempts > requiredAttempts) {
              $('label[for="serial"]').css("margin-bottom","0px");
              $('#registration_status_short_code').val("invalid_serial");
              return true;
            } else {
              if(data.message.indexOf("invalid purchase date specified") < 0 ) {
                $("#model").val('');
                $('#product').val('');
              } else {
                $("#serial").trigger('focus');
              }
              if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                $('label[for="serial"]').css("margin-bottom","70px");
              } else {
                $('label[for="serial"]').css("margin-bottom","40px");
              }
              var msg = translate(data.message);
              return "\"" + msg + "\"";
            }
          }
        }
      }
    });
    $('#serial').on('keyup',function(e){
      e.stopPropagation();
      $("#serial").removeClass("invalid");
      $('label[for="serial"].invalid').html("");
      $('label[for="serial"]').css("margin-bottom","0px");
    });
    $('#model').on('change blur', function () {
      $('#serial').removeData("previousValue");
    });
    $('#purchase_date').on('change', function () {
      $('#serial').removeData("previousValue");
    });
  }
});


$(document).ready(function() {
  if (!localStorage.bannerClosed) { 
    const isHomeOrReg = window.location.pathname === "/" || window.location.pathname === "/reg" || window.location.pathname.indexOf("/reg/") !== -1  ;
    const isLocaleHomeOrReg = window.location.pathname === "/" + $.currentLocale || window.location.pathname === "/" + $.currentLocale + "/reg" || window.location.pathname == "/"+ $.currentLocale +"/";

    if (isHomeOrReg || isLocaleHomeOrReg) {
      $('.cookieinfo-banner').css('display', 'inherit');
    }
    else {
      $('.cookieinfo-banner').css('display', 'none');
    } 
  } else {
      $('.cookieinfo-banner').css('display', 'none');
  }

  $('.cookieinfo-accept').on('click', function() {
    $('.cookieinfo-banner').css('display', 'none');
    $('#cookie_policy_accepted').val(1);
    localStorage.bannerClosed = 'true'
  });
});
$(function() {
  if ($('.mask-date').length > 0) {
    $('.mask-date').each(function(){
      var p_date = $(this).attr('id');
      p_date = "#"+p_date;

      if(!$(p_date).prop('required')){
        $(p_date).rules('add', {
          futureDate: false
        });
      } else {
        $(p_date).rules('add', {
          futureDate: true,
          messages: {
            // futureDate correct here?
            futureDate: $.polyglot.t('validations.required')
          }
        });
      }
   });
    $('.mask-date').on('keyup blur', function() {
      var p_date = "#"+$(this).attr('id');
      if((isFutureDate($(p_date).val())) ){
        $(p_date).rules('add', {
          futureDate: true,
          messages: {
            futureDate: $.polyglot.t('validations.date_not_in_future')
          }
        });
      } else {
        if(!$(p_date).prop('required')){
          $(p_date).rules('add', {
            futureDate: false
          });
        } else {
          $(p_date).rules('add', {
            futureDate: true,
            messages: {
              // futureDate correct here?
              futureDate: $.polyglot.t('validations.required')
            }
          });
        }
      }
    });
  }

  /* Check given purchase date is future date or not */
  function isFutureDate(idate){
    var today = new Date().getTime(),
      idate = idate.split("/");
    idate = new Date(idate[2], idate[1] - 1, idate[0]).getTime();
    //console.log("idate:"+idate);
    return (today - idate) < 0 ? true : false;
  }
  // Calendar keyboard keys
  $(document).on("keydown", ".datepicker", function (e) {

    const dp = $.datepicker._getInst(this);

    if (!dp) return;

    switch (e.key) {

        case "ArrowLeft":
            e.preventDefault();
            $.datepicker._adjustDate(this, -1, "D");
            break;

        case "ArrowRight":
            e.preventDefault();
            $.datepicker._adjustDate(this, +1, "D");
            break;

        case "ArrowUp":
            e.preventDefault();
            $.datepicker._adjustDate(this, -7, "D");
            break;

        case "ArrowDown":
            e.preventDefault();
            $.datepicker._adjustDate(this, +7, "D");
            break;
    }
  });
  
});